// frontend/src/components/admin/modules/ResultsManager.js
import { api } from '../../../services/api.js';
import { Notification } from '../../../components/Notification.js';
import moment from 'moment-timezone';

const VENEZUELA_TIMEZONE = 'America/Caracas';

// =================================================================================
// ⭐ GESTIÓN DE RESULTADOS (renderRaceResultsManagement) - VISTA TABLA OFICIAL ⭐
// =================================================================================
export async function renderRaceResultsManagement(container, notificationContainer) {
    // 1. Obtener la tasa actual antes de renderizar
    let currentExchangeRate = 1;
    try {
        const config = await api.get('/configs/cashier');
        const configData = Array.isArray(config) ? config[0] : config;
        if (configData && configData.exchange_rate) {
            currentExchangeRate = parseFloat(configData.exchange_rate);
        }
    } catch (error) {
        console.error("Error obteniendo tasa:", error);
    }

    container.innerHTML = `
        <h4>Registrar Resultados y Ajustar Tiempos</h4>
        <p>Selecciona una carrera para gestionar sus resultados, ajustar su hora de salida o forzar el cierre.</p>
        
        <div class="form-grid">
            <div class="form-group">
                <label for="trackFilterForResults">Filtrar por Hipódromo:</label>
                <select id="trackFilterForResults" class="remate-select"></select>
            </div>
            <div class="form-group">
                <label for="selectRaceForResults">Seleccionar Carrera:</label>
                <select id="selectRaceForResults" class="remate-select"></select>
            </div>
        </div>

        <div id="raceControlPanel" class="hidden mt-4 p-4 rounded-lg bg-[#1e293b] border border-[#334155] shadow-lg">
            <h5 class="mb-3 font-bold text-[#D4AF37] border-b border-[#334155] pb-2">⏱️ Control de Tiempo y Estado</h5>
            <div class="flex flex-wrap items-end gap-4">
                <div class="form-group flex-grow max-w-xs mb-0">
                    <label for="addMinutesSelect" class="text-sm font-semibold text-[#94a3b8] block mb-2">Añadir Minutos al Inicio:</label>
                    <div class="flex">
                        <select id="addMinutesSelect" class="remate-select rounded-r-none border-r-0" style="width: auto; flex-grow: 1;">
                            <option value="0">0 min</option>
                            <option value="1">1 min</option>
                            <option value="2">2 min</option>
                            <option value="3">3 min</option>
                            <option value="4">4 min</option>
                            <option value="5">5 min</option>
                        </select>
                        <button class="btn btn-primary rounded-l-none" id="saveTimeAdjustmentBtn" style="padding: 10px 20px;">Ajustar</button>
                    </div>
                </div>
                
                <div class="ml-auto">
                    <button class="btn btn-danger font-bold uppercase tracking-wider" id="forceCloseRaceBtn">
                        <i class="fas fa-lock mr-2"></i> Cerrar Apuestas
                    </button>
                </div>
            </div>
            <div class="mt-3 bg-[#0f172a] p-2 rounded border border-[#475569] inline-block">
                <span id="currentStartTimeDisplay" class="text-sm text-[#38bdf8] font-mono"></span>
            </div>
        </div>

        <div id="raceResultsForm" class="hidden mt-6" style="background:#14532d; border:2px solid #D4AF37; border-radius:8px; padding:15px; box-shadow: 0 8px 15px rgba(0,0,0,0.5);">
            
            <h4 style="color:#D4AF37; text-align:center; font-weight:900; font-size:1.5rem; margin-top:0; border-bottom:2px solid #D4AF37; padding-bottom:10px; margin-bottom:15px; text-transform:uppercase;">
                <i class="fas fa-trophy"></i> REGISTRAR RESULTADOS OFICIALES
            </h4>
            
            <div class="flex items-center justify-center gap-3 mb-6 bg-[#064e3b] p-3 rounded border border-[#D4AF37] mx-auto w-fit shadow-inner">
                <input type="checkbox" id="enableBsDividends" class="w-5 h-5 text-[#D4AF37] rounded cursor-pointer accent-[#D4AF37]">
                <label for="enableBsDividends" class="font-bold text-white cursor-pointer select-none text-sm uppercase tracking-wide m-0">
                    Ingresar Dividendos en Bolívares (Bs)
                </label>
                <span class="ml-2 text-sm font-mono bg-[#022c22] text-[#4ade80] px-3 py-1 rounded border border-[#047857]">
                    Tasa: ${currentExchangeRate.toFixed(2)} Bs/$
                </span>
            </div>

            <div style="overflow-x:auto;">
                <table style="width:100%; border-collapse:collapse; text-align:center; color:white; min-width: 600px;">
                    <thead>
                        <tr style="background:#064e3b; color:#D4AF37; font-size:1rem; text-transform:uppercase;">
                            <th style="padding:12px; border-bottom:2px solid #D4AF37; width: 60px;">Lugar</th>
                            <th style="padding:12px; border-bottom:2px solid #D4AF37; text-align:left;">Ejemplar</th>
                            <th style="padding:12px; border-bottom:2px solid #D4AF37; width: 120px;">Win</th>
                            <th style="padding:12px; border-bottom:2px solid #D4AF37; width: 120px;">Place</th>
                            <th style="padding:12px; border-bottom:2px solid #D4AF37; width: 120px;">Show</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="background:rgba(255,255,255,0.05); border-bottom:1px solid #334155; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.1)'" onmouseout="this.style.background='rgba(255,255,255,0.05)'">
                            <td style="padding:12px; font-size:1.8rem; font-weight:900; color:#FCD34D;">1°<br><button type="button" class="btn-add-tie" data-pos="1" style="font-size:0.6rem; background:#ef4444; color:white; border:none; padding:3px 6px; border-radius:4px; cursor:pointer; margin-top:5px;">+ Empate</button></td>
                            <td style="padding:12px; text-align:left;">
                                <select id="firstPlace" class="remate-select w-full border-[#D4AF37] font-bold" style="background:#0f172a; padding:10px;"></select>
                            </td>
                            <td style="padding:12px;">
                                <input type="number" id="winPayoff" class="remate-input text-center text-green-400 font-bold w-full usd-input" style="font-size:1.1rem; background:#022c22;" placeholder="$ USD" min="0" step="0.01">
                                <input type="number" id="winPayoffBs" class="remate-input text-center text-green-400 font-bold w-full bs-input hidden" style="font-size:1.1rem; background:#022c22; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                            </td>
                            <td style="padding:12px;">
                                <input type="number" id="placePayoff" class="remate-input text-center text-blue-400 font-bold w-full usd-input" style="font-size:1.1rem; background:#022c22;" placeholder="$ USD" min="0" step="0.01">
                                <input type="number" id="placePayoffBs" class="remate-input text-center text-blue-400 font-bold w-full bs-input hidden" style="font-size:1.1rem; background:#022c22; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                            </td>
                            <td style="padding:12px;">
                                <input type="number" id="showPayoff" class="remate-input text-center text-gray-300 font-bold w-full usd-input" style="font-size:1.1rem; background:#022c22;" placeholder="$ USD" min="0" step="0.01">
                                <input type="number" id="showPayoffBs" class="remate-input text-center text-gray-300 font-bold w-full bs-input hidden" style="font-size:1.1rem; background:#022c22; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                            </td>
                        </tr>
                        
                        <tr style="border-bottom:1px solid #334155; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.05)'" onmouseout="this.style.background='transparent'">
                            <td style="padding:12px; font-size:1.8rem; font-weight:900; color:#e2e8f0;">2°<br><button type="button" class="btn-add-tie" data-pos="2" style="font-size:0.6rem; background:#ef4444; color:white; border:none; padding:3px 6px; border-radius:4px; cursor:pointer; margin-top:5px;">+ Empate</button></td>
                            <td style="padding:12px; text-align:left;">
                                <select id="secondPlace" class="remate-select w-full font-bold" style="background:#0f172a; padding:10px;"></select>
                            </td>
                            <td style="padding:12px;"><span class="text-gray-500 font-bold text-2xl">-</span></td>
                            <td style="padding:12px;">
                                <input type="number" id="placePayoff2" class="remate-input text-center text-blue-400 font-bold w-full usd-input" style="font-size:1.1rem; background:#0f172a;" placeholder="$ USD" min="0" step="0.01">
                                <input type="number" id="placePayoff2Bs" class="remate-input text-center text-blue-400 font-bold w-full bs-input hidden" style="font-size:1.1rem; background:#0f172a; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                            </td>
                            <td style="padding:12px;">
                                <input type="number" id="showPayoff2" class="remate-input text-center text-gray-300 font-bold w-full usd-input" style="font-size:1.1rem; background:#0f172a;" placeholder="$ USD" min="0" step="0.01">
                                <input type="number" id="showPayoff2Bs" class="remate-input text-center text-gray-300 font-bold w-full bs-input hidden" style="font-size:1.1rem; background:#0f172a; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                            </td>
                        </tr>

                        <tr style="background:rgba(255,255,255,0.05); border-bottom:1px solid #334155; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.1)'" onmouseout="this.style.background='rgba(255,255,255,0.05)'">
                            <td style="padding:12px; font-size:1.8rem; font-weight:900; color:#b45309;">3°<br><button type="button" class="btn-add-tie" data-pos="3" style="font-size:0.6rem; background:#ef4444; color:white; border:none; padding:3px 6px; border-radius:4px; cursor:pointer; margin-top:5px;">+ Empate</button></td>
                            <td style="padding:12px; text-align:left;">
                                <select id="thirdPlace" class="remate-select w-full font-bold" style="background:#0f172a; padding:10px;"></select>
                            </td>
                            <td style="padding:12px;"><span class="text-gray-500 font-bold text-2xl">-</span></td>
                            <td style="padding:12px;"><span class="text-gray-500 font-bold text-2xl">-</span></td>
                            <td style="padding:12px;">
                                <input type="number" id="showPayoff3" class="remate-input text-center text-gray-300 font-bold w-full usd-input" style="font-size:1.1rem; background:#022c22;" placeholder="$ USD" min="0" step="0.01">
                                <input type="number" id="showPayoff3Bs" class="remate-input text-center text-gray-300 font-bold w-full bs-input hidden" style="font-size:1.1rem; background:#022c22; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-4 bg-[#0f172a] p-4 rounded-lg border border-[#D4AF37] flex flex-col md:flex-row justify-between items-center gap-4">
                <div class="text-[#D4AF37] font-bold text-xl uppercase tracking-widest flex items-center gap-2">
                    <i class="fas fa-star text-yellow-400"></i> Trifecta (1-2-3):
                </div>
                <div class="w-full md:w-64">
                    <input type="number" id="trifectaPayoff" class="remate-input text-center text-purple-400 font-bold text-2xl w-full usd-input" style="background:#1e1b4b; border-color:#a855f7;" placeholder="$ USD" min="0" step="0.01">
                    <input type="number" id="trifectaPayoffBs" class="remate-input text-center text-purple-400 font-bold text-2xl w-full bs-input hidden" style="background:#1e1b4b; border-color:#a855f7;" placeholder="Monto Bs." min="0" step="0.01">
                </div>
            </div>

            <button class="btn btn-success mt-6 w-full font-bold py-4 text-xl uppercase tracking-widest shadow-xl flex justify-center items-center gap-3 transition-transform hover:scale-[1.02]" id="submitResultsBtn" style="border-radius: 8px; background: linear-gradient(135deg, #D4AF37 0%, #b48505 100%); color: black; border: none;">
                <i class="fas fa-check-circle text-2xl"></i> SELLAR RESULTADOS Y PAGAR
            </button>
        </div>
    `;

    // --- Referencias del DOM ---
    const trackFilterForResults = container.querySelector('#trackFilterForResults');
    const selectRaceForResults = container.querySelector('#selectRaceForResults');
    
    const raceControlPanel = container.querySelector('#raceControlPanel');
    const addMinutesSelect = container.querySelector('#addMinutesSelect');
    const saveTimeAdjustmentBtn = container.querySelector('#saveTimeAdjustmentBtn');
    const forceCloseRaceBtn = container.querySelector('#forceCloseRaceBtn');
    const currentStartTimeDisplay = container.querySelector('#currentStartTimeDisplay');

    const raceResultsForm = container.querySelector('#raceResultsForm');
    const firstPlaceSelect = container.querySelector('#firstPlace');
    const secondPlaceSelect = container.querySelector('#secondPlace');
    const thirdPlaceSelect = container.querySelector('#thirdPlace');
    
    const winPayoffInput = container.querySelector('#winPayoff');
    const placePayoffInput = container.querySelector('#placePayoff');
    const placePayoff2Input = container.querySelector('#placePayoff2');
    const showPayoffInput = container.querySelector('#showPayoff');
    const showPayoff2Input = container.querySelector('#showPayoff2');
    const showPayoff3Input = container.querySelector('#showPayoff3');
    const trifectaPayoffInput = container.querySelector('#trifectaPayoff');
    const submitResultsBtn = container.querySelector('#submitResultsBtn');

    const enableBsCheckbox = container.querySelector('#enableBsDividends');
    const allUsdInputs = container.querySelectorAll('.usd-input');
    const allBsInputs = container.querySelectorAll('.bs-input');
    const winPayoffBsInput = container.querySelector('#winPayoffBs');
    const placePayoffBsInput = container.querySelector('#placePayoffBs');
    const placePayoff2BsInput = container.querySelector('#placePayoff2Bs');
    const showPayoffBsInput = container.querySelector('#showPayoffBs');
    const showPayoff2BsInput = container.querySelector('#showPayoff2Bs');
    const showPayoff3BsInput = container.querySelector('#showPayoff3Bs');
    const trifectaPayoffBsInput = container.querySelector('#trifectaPayoffBs');

    let allRacesForResults = [];
    let selectedRaceData = null;

    // ⭐ FIX POKA-YOKE: Actualizado para detectar dinámicamente las filas clonadas
    enableBsCheckbox.addEventListener('change', (e) => {
        container.querySelectorAll('.usd-input').forEach(el => el.classList.toggle('hidden', e.target.checked));
        container.querySelectorAll('.bs-input').forEach(el => el.classList.toggle('hidden', !e.target.checked));
        if (!e.target.checked) container.querySelectorAll('.bs-input').forEach(el => el.value = '');
    });

    const updateUsdField = (bsValue, usdInputElement) => {
        const val = parseFloat(bsValue);
        if (isNaN(val)) {
            usdInputElement.value = '';
            return;
        }

        // ⭐ FIX POKA-YOKE: Si es La Rinconada o Valencia, pasamos el valor INTACTO (Sin dividir entre la tasa)
        // La base de datos debe guardar los Bolívares puros ingresados por el supervisor.
        if (selectedRaceData && selectedRaceData.track_name) {
            const trackName = selectedRaceData.track_name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            if (trackName.includes('rinconada') || trackName.includes('valencia')) {
                usdInputElement.value = val;
                return;
            }
        }
        
        // Si es Internacional, sí lo convertimos a Dólares
        usdInputElement.value = (currentExchangeRate > 0) ? (val / currentExchangeRate).toFixed(6) : '';
    };

    winPayoffBsInput.addEventListener('input', (e) => updateUsdField(e.target.value, winPayoffInput));
    placePayoffBsInput.addEventListener('input', (e) => updateUsdField(e.target.value, placePayoffInput));
    placePayoff2BsInput.addEventListener('input', (e) => updateUsdField(e.target.value, placePayoff2Input));
    showPayoffBsInput.addEventListener('input', (e) => updateUsdField(e.target.value, showPayoffInput));
    showPayoff2BsInput.addEventListener('input', (e) => updateUsdField(e.target.value, showPayoff2Input));
    showPayoff3BsInput.addEventListener('input', (e) => updateUsdField(e.target.value, showPayoff3Input));
    trifectaPayoffBsInput.addEventListener('input', (e) => updateUsdField(e.target.value, trifectaPayoffInput));

    const loadInitialDataForResults = async () => {
         try {
            const trackResponse = await api.get('/tracks?admin_mode=true');
            const tracks = trackResponse.tracks || trackResponse;
            if (!Array.isArray(tracks)) throw new Error("Formato de respuesta de hipódromos inválido");
            
            trackFilterForResults.innerHTML = '<option value="">-- Todos los Hipódromos --</option>' +
                tracks.map(track => `<option value="${track.id}">${track.name}</option>`).join('');

            const rawRaces = await api.get('/races');
            
            // ⭐ FIX: Filtrar estrictamente para mostrar SOLO las carreras del día de hoy
            const todayStr = moment().tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DD');
            allRacesForResults = rawRaces.filter(r => {
                if (!r.start_time) return false;
                const raceDate = moment.utc(r.start_time).tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DD');
                return raceDate === todayStr;
            });

            populateRacesDropdownForResults(allRacesForResults.filter(r => r.status !== 'finished'));
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cargar datos iniciales.', 'error');
        }
    };

    const populateRacesDropdownForResults = (races) => {
        selectRaceForResults.innerHTML = '<option value="">-- Seleccionar una carrera --</option>';
        races.forEach(race => {
            const option = document.createElement('option');
            option.value = race.id;
            const raceStartTimeLocal = moment.utc(race.start_time).tz(VENEZUELA_TIMEZONE);
            option.textContent = `Carrera #${race.race_number} - ${race.name} (${raceStartTimeLocal.format('HH:mm')}) - ${race.track_name}`;
            selectRaceForResults.appendChild(option);
        });
    };
    
    trackFilterForResults.addEventListener('change', () => {
        const selectedTrackId = trackFilterForResults.value;
        const filteredRaces = (selectedTrackId 
            ? allRacesForResults.filter(race => race.track_id == selectedTrackId)
            : allRacesForResults)
            .filter(r => r.status !== 'finished');
        
        populateRacesDropdownForResults(filteredRaces);
        raceResultsForm.classList.add('hidden');
        raceControlPanel.classList.add('hidden');
        selectedRaceData = null;
    });

    selectRaceForResults.addEventListener('change', async (e) => {
        const selectedRaceId = e.target.value;
        
        [...allUsdInputs, ...allBsInputs].forEach(input => input.value = '');

        if (selectedRaceId) {
            selectedRaceData = allRacesForResults.find(r => r.id == selectedRaceId);
            
            if (selectedRaceData && selectedRaceData.track_name) {
                const trackName = selectedRaceData.track_name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                if (trackName.includes('rinconada') || trackName.includes('valencia')) {
                    enableBsCheckbox.checked = true;
                    enableBsCheckbox.disabled = true; // Bloquea la casilla
                } else {
                    enableBsCheckbox.checked = false;
                    enableBsCheckbox.disabled = false; // Habilita la casilla
                }
            } else {
                enableBsCheckbox.checked = false;
                enableBsCheckbox.disabled = false;
            }
            enableBsCheckbox.dispatchEvent(new Event('change'));

            if (selectedRaceData) {
                 const timeLocal = moment.utc(selectedRaceData.start_time).tz(VENEZUELA_TIMEZONE).format('DD/MM/YYYY HH:mm:ss');
                 const statusIcon = selectedRaceData.status === 'closed' ? '🔒' : '🟢';
                 currentStartTimeDisplay.innerHTML = `<i class="far fa-clock"></i> Hora de inicio BD: <b>${timeLocal}</b> &nbsp;&nbsp; Estado: ${statusIcon} <b>${selectedRaceData.status.toUpperCase()}</b>`;
            }

            try {
                const horsesInRace = await api.get(`/races/${selectedRaceId}/horses`);
                const createHorseOptions = (selectElem) => {
                    if (!selectElem) return; 
                    selectElem.innerHTML = '<option value="">-- Seleccionar Caballo --</option>';
                    
                    // ⭐ FIX POKA-YOKE: Ordenamiento matemático para evitar que el DB Heap desordene los caballos
                    // y blindaje de la lectura de is_scratched para evitar falsos positivos
                    const validHorses = horsesInRace.filter(h => h.is_scratched !== true && h.is_scratched !== 'true' && h.is_scratched !== 1);
                    
                    validHorses.sort((a, b) => parseInt(a.horse_number || 0) - parseInt(b.horse_number || 0));

                    validHorses.forEach(horse => {
                        const option = document.createElement('option');
                        option.value = horse.horse_id || horse.id; // Fallback por si la API cambia
                        const hName = horse.horse_name || horse.name || 'Ejemplar';
                        option.textContent = `#${horse.horse_number} - ${hName}`;
                        selectElem.appendChild(option);
                    });
                };
                
                createHorseOptions(firstPlaceSelect);
                createHorseOptions(secondPlaceSelect);
                createHorseOptions(thirdPlaceSelect);
                
                raceControlPanel.classList.remove('hidden'); 
                raceResultsForm.classList.remove('hidden'); 
            } catch (error) {
                Notification(notificationContainer, error.message || 'Error al cargar participantes.', 'error');
                raceResultsForm.classList.add('hidden');
                raceControlPanel.classList.add('hidden');
            }
        } else {
            enableBsCheckbox.checked = false;
            enableBsCheckbox.disabled = false;
            enableBsCheckbox.dispatchEvent(new Event('change'));

            raceResultsForm.classList.add('hidden');
            raceControlPanel.classList.add('hidden');
            selectedRaceData = null;
        }
    });

    saveTimeAdjustmentBtn.addEventListener('click', async () => {
        if (!selectedRaceData) return;
        const minutesToAdd = parseInt(addMinutesSelect.value);
        if (minutesToAdd === 0) return Notification(notificationContainer, 'Seleccione minutos a ajustar.', 'info');

        try {
            const newStartTime = moment.utc(selectedRaceData.start_time).add(minutesToAdd, 'minutes').toISOString();
            await api.put(`/races/${selectedRaceData.id}`, { start_time: newStartTime });
            Notification(notificationContainer, `Se añadieron ${minutesToAdd} minutos exitosamente.`, 'success');
            selectedRaceData.start_time = newStartTime;
            const timeLocal = moment.utc(newStartTime).tz(VENEZUELA_TIMEZONE).format('DD/MM/YYYY HH:mm:ss');
            currentStartTimeDisplay.innerHTML = `<i class="far fa-clock"></i> Hora de inicio BD: <b>${timeLocal}</b> &nbsp;&nbsp; Estado: 🟢 <b>${selectedRaceData.status.toUpperCase()}</b>`;
            addMinutesSelect.value = "0";
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al ajustar el tiempo.', 'error');
        }
    });

    forceCloseRaceBtn.addEventListener('click', async () => {
        if (!selectedRaceData || !confirm(`⚠️ ¿CERRAR las apuestas para la carrera #${selectedRaceData.race_number}?`)) return;

        try {
            const nowUTC = moment().utc().toISOString();
            await api.put(`/races/${selectedRaceData.id}`, { status: 'closed', start_time: nowUTC });
            Notification(notificationContainer, 'Carrera CERRADA y hora actualizada.', 'success');
            selectedRaceData.status = 'closed';
            selectedRaceData.start_time = nowUTC;
            const timeLocal = moment.utc(nowUTC).tz(VENEZUELA_TIMEZONE).format('DD/MM/YYYY HH:mm:ss');
            currentStartTimeDisplay.innerHTML = `<i class="far fa-clock"></i> Hora actual en BD: <b>${timeLocal}</b> &nbsp;&nbsp; Estado: 🔒 <b>CLOSED</b>`;
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cerrar la carrera.', 'error');
        }
    });

    // ⭐ POKA-YOKE: Creador Dinámico de Filas de Empate
    container.addEventListener('click', (e) => {
        if (e.target.closest('.btn-add-tie')) {
            const btn = e.target.closest('.btn-add-tie');
            const pos = btn.dataset.pos;
            const primaryRow = btn.closest('tr');
            
            const tr = document.createElement('tr');
            tr.className = `tie-row pos-${pos}`;
            tr.style.background = 'rgba(239, 68, 68, 0.1)';
            tr.style.borderBottom = '1px solid #334155';
            
            let optionsHtml = '';
            if (pos === '1') optionsHtml = firstPlaceSelect.innerHTML;
            if (pos === '2') optionsHtml = secondPlaceSelect.innerHTML;
            if (pos === '3') optionsHtml = thirdPlaceSelect.innerHTML;

            const isHiddenUSD = enableBsCheckbox.checked ? 'hidden' : '';
            const isHiddenBS = !enableBsCheckbox.checked ? 'hidden' : '';

            tr.innerHTML = `
                <td style="padding:12px; font-size:1.2rem; font-weight:bold; color:#ef4444;">E-${pos}°<br><button type="button" class="btn-remove-tie" style="font-size:0.7rem; color:#ef4444; background:none; border:none; cursor:pointer; margin-top:5px;">(Quitar)</button></td>
                <td style="padding:12px; text-align:left;">
                    <select class="remate-select tie-horse w-full font-bold" style="background:#0f172a; padding:10px;">${optionsHtml}</select>
                </td>
                <td style="padding:12px;">
                    <input type="number" class="remate-input tie-win-usd text-center text-green-400 font-bold w-full usd-input ${isHiddenUSD}" style="font-size:1.1rem; background:#0f172a;" placeholder="$ USD" min="0" step="0.01">
                    <input type="number" class="remate-input tie-win-bs text-center text-green-400 font-bold w-full bs-input ${isHiddenBS}" style="font-size:1.1rem; background:#0f172a; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                </td>
                <td style="padding:12px;">
                    <input type="number" class="remate-input tie-place-usd text-center text-blue-400 font-bold w-full usd-input ${isHiddenUSD}" style="font-size:1.1rem; background:#0f172a;" placeholder="$ USD" min="0" step="0.01">
                    <input type="number" class="remate-input tie-place-bs text-center text-blue-400 font-bold w-full bs-input ${isHiddenBS}" style="font-size:1.1rem; background:#0f172a; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                </td>
                <td style="padding:12px;">
                    <input type="number" class="remate-input tie-show-usd text-center text-gray-300 font-bold w-full usd-input ${isHiddenUSD}" style="font-size:1.1rem; background:#0f172a;" placeholder="$ USD" min="0" step="0.01">
                    <input type="number" class="remate-input tie-show-bs text-center text-gray-300 font-bold w-full bs-input ${isHiddenBS}" style="font-size:1.1rem; background:#0f172a; border-color:#047857;" placeholder="Bs." min="0" step="0.01">
                </td>
            `;
            
            primaryRow.after(tr);

            // Re-asignamos los listeners de conversión para las nuevas casillas clonadas
            const usdWin = tr.querySelector('.tie-win-usd'); const bsWin = tr.querySelector('.tie-win-bs');
            bsWin.addEventListener('input', (e) => updateUsdField(e.target.value, usdWin));
            const usdPlace = tr.querySelector('.tie-place-usd'); const bsPlace = tr.querySelector('.tie-place-bs');
            bsPlace.addEventListener('input', (e) => updateUsdField(e.target.value, usdPlace));
            const usdShow = tr.querySelector('.tie-show-usd'); const bsShow = tr.querySelector('.tie-show-bs');
            bsShow.addEventListener('input', (e) => updateUsdField(e.target.value, usdShow));
        }

        if (e.target.closest('.btn-remove-tie')) e.target.closest('tr').remove();
    });

    submitResultsBtn.addEventListener('click', async () => {
        const raceId = parseInt(selectRaceForResults.value);
        
        // ⭐ POKA-YOKE: Ensamblaje del Payload con Empates (Dead Heats)
        const deadHeats = {};
        container.querySelectorAll('.tie-row').forEach(row => {
            const pos = row.classList.contains('pos-1') ? '1' : (row.classList.contains('pos-2') ? '2' : '3');
            const hId = parseInt(row.querySelector('.tie-horse').value);
            if (!hId) return;
            
            const winVal = row.querySelector('.tie-win-usd').value;
            const placeVal = row.querySelector('.tie-place-usd').value;
            const showVal = row.querySelector('.tie-show-usd').value;

            if (!deadHeats[pos]) deadHeats[pos] = [];
            deadHeats[pos].push({
                horse_id: hId,
                win_payoff: winVal ? parseFloat(winVal) : null,
                place_payoff: placeVal ? parseFloat(placeVal) : null,
                show_payoff: showVal ? parseFloat(showVal) : null
            });
        });

        const payload = {
            first_place_horse_id: firstPlaceSelect.value ? parseInt(firstPlaceSelect.value) : null,
            second_place_horse_id: secondPlaceSelect.value ? parseInt(secondPlaceSelect.value) : null,
            third_place_horse_id: thirdPlaceSelect.value ? parseInt(thirdPlaceSelect.value) : null,
            win_payoff: winPayoffInput.value ? parseFloat(winPayoffInput.value) : null,
            place_payoff: placePayoffInput.value ? parseFloat(placePayoffInput.value) : null,
            place_payoff_2: placePayoff2Input.value ? parseFloat(placePayoff2Input.value) : null,
            show_payoff: showPayoffInput.value ? parseFloat(showPayoffInput.value) : null,
            show_payoff_2: showPayoff2Input.value ? parseFloat(showPayoff2Input.value) : null,
            show_payoff_3: showPayoff3Input.value ? parseFloat(showPayoff3Input.value) : null,
            trifecta_payoff: trifectaPayoffInput.value ? parseFloat(trifectaPayoffInput.value) : null,
            dead_heats: Object.keys(deadHeats).length > 0 ? deadHeats : null
        };

        if (!raceId || !payload.first_place_horse_id) {
            return Notification(notificationContainer, 'Debes seleccionar una carrera y al menos el primer lugar.', 'error');
        }

        try {
            submitResultsBtn.disabled = true;
            submitResultsBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> PROCESANDO...';

            await api.post(`/races/${raceId}/results`, { ...payload, status: 'finished' });
            await api.post(`/remate/races/${raceId}/finalize`, { raceId, ...payload });
            await api.post(`/remate/pay-digital`, { raceId, ...payload });
            
            Notification(notificationContainer, '✅ Resultados oficiales sellados y premios pagados.', 'success');
            
            raceResultsForm.classList.add('hidden');
            raceControlPanel.classList.add('hidden');
            selectRaceForResults.value = '';
            
            // Limpia las filas de empates residuales
            container.querySelectorAll('.tie-row').forEach(r => r.remove());
            
            await loadInitialDataForResults();

        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al registrar resultados.', 'error');
        } finally {
            submitResultsBtn.disabled = false;
            submitResultsBtn.innerHTML = '<i class="fas fa-check-circle text-2xl"></i> SELLAR RESULTADOS Y PAGAR';
        }
    });

    await loadInitialDataForResults();
}